import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { Skeleton, SkeletonTextBlock, tokens } from '@fhs/ui';

import { useChallengeCardWidth } from '../challenge-card/challenge-card';

export function ChallengeCardSkeleton({ style }: { style?: StyleProp<ViewStyle> }) {
  const itemWidth = useChallengeCardWidth();

  return (
    <View style={[{ width: itemWidth }, styles.card, style]}>
      <Skeleton style={styles.image} />
      <View style={styles.content}>
        <SkeletonTextBlock lines={3} />
        <Skeleton style={styles.skeletonButton} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderColor: tokens.colors.$blackOpacity10,
    borderWidth: 1,
    borderRadius: 8,
    overflow: 'hidden',
  },
  image: {
    height: 180,
    borderRadius: 0,
  },
  content: {
    padding: 12,
    borderTopWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
  },
  skeletonButton: {
    height: 31,
    marginTop: 16,
  },
});
